module.exports = __webpack_public_path__ + "9779d9a1/img/scraper-icon.df6ccde5.svg";